import React from "react";

export function CartIcon(): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.444"
      height="23.444"
      viewBox="0 0 129.177 129.181"
      display="block"
      fill="currentColor"
    >
      <g
        id="noun_Shopping_Cart_984637"
        data-name="noun_Shopping Cart_984637"
        transform="translate(-18 -18)"
      >
        <path
          id="Path_2399"
          data-name="Path 2399"
          d="M122.959,110.849H62.406a8.074,8.074,0,0,1-7.69-5.631L32.27,34.148h-6.2a8.074,8.074,0,1,1,0-16.148H38.184a8.074,8.074,0,0,1,7.69,5.652l5.874,18.57h87.358a8.074,8.074,0,0,1,7.71,10.456l-16.148,52.48A8.074,8.074,0,0,1,122.959,110.849ZM58.369,135.07A12.111,12.111,0,1,0,70.48,122.959,12.111,12.111,0,0,0,58.369,135.07Zm44.406,0a12.111,12.111,0,1,0,12.111-12.111A12.111,12.111,0,0,0,102.775,135.07Z"
        />
      </g>
    </svg>
  );
}
